module.exports = __webpack_public_path__ + "static/assets/67484e58e0fb594909d768bea10195eb.svg";